var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6.39067L11.0941 3H5.95C5.43283 3 4.93684 3.21071 4.57114 3.58579C4.20545 3.96086 4 4.46957 4 5V16.3333H14.4V6.39067ZM5.3 15V5C5.3 4.82319 5.36848 4.65362 5.49038 4.5286C5.61228 4.40357 5.77761 4.33333 5.95 4.33333H10.5V7H13.1V15H5.3ZM17 9V19H7.25V17.6667H15.7V7.66667L17 9Z",
    fill: "#26445A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyItem);
export default __webpack_public_path__ + "static/media/CopyItem.5f190df82140734d955b1f28d676a708.svg";
export { ForwardRef as ReactComponent };